module.exports = __webpack_public_path__ + "static/img/2.995e8c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Iverland/2.jpg
// module id = QtKJ
// module chunks = 0